export enum AlertType {
    error,
    success,
    confirm,
    info
}

export enum LeadStatus {
    Pending = 'Pending',
    Accepted = 'Accepted',
    Rejected = 'Rejected'
}

export enum InstallerStatus {
    Pending = 'pending',
    Accepted = 'accepted',
    Rejected = 'rejected',
    Recommended = 'recommended'
}

export enum ModeVal {
    fullBackup = 0,
    energyIndependence = 1,
    savings = 2
}

export enum Savings {
    paymentFactor = 0.00839,
    loanIntRate = 8.99,
    loanTerm = 25
}

export enum ConsumptionProfileEnum {
  defaultResidential = 0,
  householdWithSchoolKids = 1,
  householdWithInfants = 2,
  singleOrTwoPerson = 3,
  workFromHomeCouple = 4,
  retireesOrWorking = 5,
  nightTimeFocussed = 6,
  custom = 7
}
